"use strict";

exports.__esModule = true;
exports["default"] = spring;

require("core-js/modules/es.object.assign.js");

var _presets = _interopRequireDefault(require("./presets"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var defaultConfig = Object.assign({}, _presets["default"].noWobble, {
  precision: 0.01
});

function spring(val, config) {
  return Object.assign({}, defaultConfig, config, {
    val: val
  });
}